import axios from 'axios'
import rulesHandler from '../../rulesHandler'
// import _ from "lodash";

const state = {
  items: [],
  skip: 0,
  limit: 15,
  total: 0,
}

const getters = {
  getItems(state, getters) {
    return state.items
  },
  getSkip(state, getters) {
    return state.skip
  },
  getLimit(state, getters) {
    return state.limit
  },
  getTotal(state, getters) {
    return state.total
  },
}

const actions = {
  //fetchCategories: (context, payload) => (paramKey) =>  {

  async fetchResult(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/result`

    return await axios
      .post(
        `${url}`,
        {
          period: payload.period,
          sport: payload.sport,
          tournament: payload.tournament,
          category: payload.category,
          competitor: payload.competitor,
          language_user: payload.language_user,
          skip: payload.skip,
          limit: payload.limit,
          timezone: payload.timezone,
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        //console.log(context.rootGetters['result/getSkip'])
        if (context.rootGetters['result/getSkip'] == 0) {
          //console.log(res.data.result)
          context.commit('setItems', res.data.result)
          context.commit('setTotal', res.data.total)
        } else {
          //console.log("prova")
          context.commit('addItems', res.data.result)
          context.commit('setTotal', res.data.total)
        }

        //context.commit('addItems',res.data.result)
        return res.data.result
      })
      .catch(error => {
        console.log(error.message)
        console.log(error.stack)
      })
  },
  async setSkip(context, payload) {
    context.commit('SET_SKIP', payload.skip)
    return
  },
  async emptyResult(context, payload) {
    context.commit('setItems', [])
    context.commit('setTotal', 0)
    context.commit('SET_SKIP', 0)
    return
  },
}

const mutations = {
  setItems(state, payload) {
    state.items = payload
  },
  setTotal(state, payload) {
    state.total = payload
  },
  setLimit(state, payload) {
    state.limit = payload
  },
  setSkip(state, payload) {
    state.skip = payload
  },
  SET_SKIP(state, payload) {
    state.skip = payload
  },
  addItems(state, payload) {
    for (const res of payload) {
      state.items.push(res)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
